var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSliders = function SvgIconSliders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.75a1 1 0 0 1 1 1v2.625q0 .139-.036.267a1.874 1.874 0 0 1 0 3.216q.036.128.036.267V20.25a1 1 0 1 1-2 0V10.125q0-.139.036-.267a1.874 1.874 0 0 1 0-3.216A1 1 0 0 1 11 6.375V3.75a1 1 0 0 1 1-1m4.875 13c0 .683.365 1.28.91 1.608a1 1 0 0 0-.035.267v2.625a1 1 0 1 0 2 0v-2.625a1 1 0 0 0-.036-.267 1.874 1.874 0 0 0 0-3.216 1 1 0 0 0 .036-.267V3.75a1 1 0 1 0-2 0v10.125a1 1 0 0 0 .036.267c-.546.327-.911.925-.911 1.608m-12.59-1.392a1 1 0 0 0-.035.267v5.625a1 1 0 1 0 2 0v-5.625a1 1 0 0 0-.036-.267 1.874 1.874 0 0 0 0-3.216 1 1 0 0 0 .036-.267V3.75a1 1 0 0 0-2 0v7.125a1 1 0 0 0 .036.267 1.874 1.874 0 0 0 0 3.217",
    clipRule: "evenodd"
  })));
};
export default SvgIconSliders;